// Minimal, fast, case-insensitive, and guards against missing local-part.
export function isCompanyEmail(email: string, domain = 'lexarhomes.com'): boolean {
    if (typeof email !== 'string') return false;
    const at = email.lastIndexOf('@');
    if (at <= 0 || at === email.length - 1) return false; // no local part or no domain
    const actualDomain = email.slice(at + 1).toLowerCase();
    return actualDomain === domain.toLowerCase();
  }
  